import React from "react";
import { ArrowRight } from "@piiqtechnologies/svg-icons";
import { PeekButton } from "@piiqtechnologies/ui-components";
export const CategoryCardButton = ({ buttonLabel, buttonOnClick, }) => {
    return (React.createElement(PeekButton, { onClick: buttonOnClick, variant: "outlined", color: "info", size: "large", endIcon: React.createElement(ArrowRight, { style: { paddingLeft: 5 } }) }, buttonLabel));
};
export default CategoryCardButton;
